export enum EMergeValue {
  Unknown = 'unknown',
  Fullname = 'fullname',
  CompanyName = 'company_name',
  SignDate = 'sign_date',
}
